/**
 * Sale cooldown — countdown + progress bar for end of promo day (GMT-3).
 */
(function () {
  const TIMEZONE_OFFSET = -3;

  function getEndOfDayUTC(day, month, year) {
    return new Date(Date.UTC(year, month - 1, day + 1, 2, 59, 59, 999));
  }

  function getStartOfDayUTC(day, month, year) {
    return new Date(Date.UTC(year, month - 1, day, 3, 0, 0, 0));
  }

  function isInTargetDay(day, month, year) {
    const now = new Date();
    const start = getStartOfDayUTC(day, month, year);
    const end = getEndOfDayUTC(day, month, year);
    return now >= start && now <= end;
  }

  function initSaleCooldown(root) {
    const day = parseInt(root.dataset.countdownDay || '1', 10);
    const month = parseInt(root.dataset.countdownMonth || '1', 10);
    const year = parseInt(root.dataset.countdownYear || '2026', 10);
    const alwaysVisible = root.dataset.alwaysVisible === 'true';
    const showTimer = root.dataset.showTimer !== 'false';

    if (!alwaysVisible && !isInTargetDay(day, month, year)) {
      root.classList.add('is-hidden');
      return;
    }

    const startOfDay = getStartOfDayUTC(day, month, year);
    const endOfDay = getEndOfDayUTC(day, month, year);
    const totalMs = endOfDay - startOfDay;

    const hoursEl = root.querySelector('.sale-cooldown__hours');
    const minutesEl = root.querySelector('.sale-cooldown__minutes');
    const secondsEl = root.querySelector('.sale-cooldown__seconds');
    const progressEl = root.querySelector('.sale-cooldown__progress-fill');
    const timerRow = root.querySelector('.sale-cooldown__timer-row');

    if (timerRow) {
      timerRow.hidden = !showTimer;
    }

    let intervalId;

    function update() {
      const now = new Date();
      let diff = endOfDay - now;

      if (diff <= 0) {
        if (intervalId) clearInterval(intervalId);
        if (!alwaysVisible) {
          root.classList.add('is-hidden');
        } else {
          if (hoursEl) hoursEl.textContent = '00';
          if (minutesEl) minutesEl.textContent = '00';
          if (secondsEl) secondsEl.textContent = '00';
          if (progressEl) progressEl.style.width = '0%';
        }
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');

      if (progressEl && totalMs > 0) {
        const elapsed = now - startOfDay;
        const remainingPct = Math.max(0, Math.min(100, ((totalMs - elapsed) / totalMs) * 100));
        progressEl.style.width = remainingPct + '%';
      }
    }

    update();
    intervalId = setInterval(update, 1000);

    const observer = new MutationObserver(() => {
      if (root.classList.contains('is-hidden') && intervalId) {
        clearInterval(intervalId);
      }
    });
    observer.observe(root, { attributes: true, attributeFilter: ['class'] });
  }

  function init(scope) {
    (scope || document).querySelectorAll('.sale-cooldown[data-countdown-day]').forEach(initSaleCooldown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:select', (event) => init(event.target));
})();
